/**
 * Thẻ "Lịch sử chỉnh sửa hồ sơ" — US A3: "mọi thay đổi được ghi log (ai sửa, khi nào,
 * giá trị cũ/mới)". Dùng chung cho Hộ và Đại lý/MM: cả hai đọc cùng bảng
 * `master_data_changes` qua `GET /<thực thể>/:id/changes`, nên hai bản hiển thị chép tay
 * sớm muộn cũng lệch nhau.
 *
 * Tải sau khi trang đã hiện: nhật ký là thông tin phụ, không đáng để chặn phần chính
 * của hồ sơ chờ thêm một request.
 */
import { esc, formatDateTime } from './util.js';
import { methodInfo, valueText } from './change-log-logic.js';

const TITLE = '<h2 class="card-title"><span class="ms">manage_history</span>Lịch sử chỉnh sửa hồ sơ (US A3)</h2>';

/**
 * @param {HTMLElement} host - thẻ card sẽ được ghi đè nội dung
 * @param {() => Promise<Array<object>>} load - vd `() => api.households.changes(id)`
 */
export async function renderChangeLog(host, load) {
  let items;
  try {
    items = await load();
  } catch (err) {
    host.innerHTML = `${TITLE}<p class="hint-text">Không tải được nhật ký: ${esc(err.message)}</p>`;
    return;
  }

  host.innerHTML = `
    ${TITLE}
    ${
      items.length
        ? `<ul class="change-log">${items.map(changeLogItem).join('')}</ul>`
        : `<p class="hint-text">Hồ sơ chưa được chỉnh sửa lần nào kể từ khi tạo.</p>`
    }`;
}

function changeLogItem(item) {
  const method = methodInfo(item.method);
  const rejected = item.method === 'proposal_rejected';
  return `<li class="change-log-item${rejected ? ' log-rejected' : ''}">
    <div class="change-log-head">
      <b>${esc(item.actor?.fullName || 'Không rõ người sửa')}</b>
      <span class="hint-text">${esc(formatDateTime(item.changedAt))}</span>
      <span class="badge status-${method.tone}">${esc(method.label)}</span>
    </div>
    <ul class="change-log-fields">
      ${item.changes
        .map(
          (c) => `<li><span>${esc(c.label)}</span>
            <span class="change-old">${esc(valueText(c.old))}</span>
            <span class="ms ms-sm">arrow_forward</span>
            <span class="change-new">${esc(valueText(c.new))}</span></li>`,
        )
        .join('')}
    </ul>
    ${item.approver ? `<div class="log-note">${rejected ? 'Người từ chối' : 'Người duyệt'}: ${esc(item.approver.fullName)}</div>` : ''}
    ${item.reason ? `<div class="log-note">Lý do: ${esc(item.reason)}</div>` : ''}
    ${item.decisionNote ? `<div class="log-note">Ghi chú người duyệt: ${esc(item.decisionNote)}</div>` : ''}
  </li>`;
}
